export default class CartBenefitsGauge extends HTMLElement {
	constructor() {
		super();
		this.el = this;
		this.numberSteps = Number(this.dataset.numberSteps);
		this.elStepTrue = Array.from(
			document.querySelectorAll('[data-cart-benefits-image]'),
		);
		this.elLastStep = this.elStepTrue.at(-1);
	}

	connectedCallback() {
		this.updateGaugeWidth();
	}

	updateGaugeWidth() {
		const width = this.calculateGaugeWidth();
		this.el.style.width = width;
	}

	calculateGaugeWidth() {
		if (this.numberSteps === this.elStepTrue.length) {
			return '100%';
		}
		if (this.elLastStep) {
			return `${this.elLastStep.offsetLeft}px`;
		}
		return '0%';
	}
}
